export default __webpack_public_path__ + "static/media/toby_mathew.f5e3131c.gif";